import Control from "../1. Core/Control";
import Delegate from "../1. Core/Delegate";
import DataTable from "../1. Core/Controls/DataTable/DataTable";
import {getSportType, IAthlete, PageMode} from "../10. Battle/types";
import NP from "../1. Core/NP";
import {ServerAPI} from "../1. Core/ServerAPI";
import {getWeightStringById} from "../10. Battle/Util";
import AthletesList, {IAthleteListItem} from "./AthletesList";

export default class SimpleAthletesList extends Control {
	private _Count: number;
	private _Offset: number;

	private EvAthleteSelected: Delegate;

	private _Athletes: IAthleteListItem[];
	private _dataTable: DataTable;
	private _AllCount: number;
	private _FilterText: string;
	private _SortField: string;
	private _SortDirection: number;
	private _Mode: PageMode;
	private _Sex: number | null;


	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this.EvAthleteSelected = new Delegate();
		this._FilterText = '';
		this._Mode = null;
		this._Sex = null;
		super._initFields(settings);
	}

	_render()
	{
		this.np_render();
		this.addClass('athletes-list');
		this._Count = 100;
		this._Offset = 0;


		this._dataTable = new DataTable({
			ParentNode: this._root,
			ShowSettingsButton: false,
			Class: 'app-list--avatars mdc-data-table--margin data-table-battle',
			MultiSelect: false,
			ShowRowIndex: true,
			ImageWidth: 32,
			Height: this._Height,
			Width: this._Width,
			Columns: [{
				Content: NP.RM.getString('Name'),
				Width: '33%',
				PropertyContent: 'Name'
			}, {
				Content: NP.RM.getString('Country'),
				PropertyContent: 'Country',
				Width: '33%'
			}, {
				Content: NP.RM.getString('WeightCategory'),
				PropertyContent: 'WeightCat',
				Width: '33%'
			}],
			ShowPaginator: true,
			EvPaginatorLeftClick: () =>
			{
				this._Offset -= this._Count;
				this.refresh();
			},
			EvItemClick: (s: object, e: { Item: IAthleteListItem }) =>
			{
				this.EvAthleteSelected.fire(this, e.Item);
			},
			EvPaginatorRightClick: () =>
			{
				this._Offset += this._Count;
				this.refresh();
			},
			EvSortClick: (s: DataTable, e: any) =>
			{
				e.CanceSort = true;

				switch (e.Column)
				{
					case 0:
						this._SortField = "Name";
						break;
					case 1:
						this._SortField = "Country";
						break;
					case 2:
						this._SortField = "Weight";
						break;
				}
				this._SortDirection = e.Direction;
				this._Offset = 0;
				this.refresh();
			},
		});

	}


	setFilter(filter: string)
	{
		this._FilterText = filter;
		this.refresh();
	}


	refresh()
	{
		this._dataTable.setRows([]);

		let payload: {
			FilterText: string;
			Offset: number;
			Count: number;
			SortField: string;
			SortDirection: number;
			SportType: ReturnType<typeof getSportType>;
			Sex?: number;
		} = {
			FilterText: this._FilterText,
			Offset: this._Offset,
			Count: this._Count,
			SortField: this._SortField,
			SortDirection: this._SortDirection,
			SportType: getSportType(this._Mode),
		};
		if (this._Sex != null) {
			payload.Sex = this._Sex;
		}

		ServerAPI.callUiApi("/athlete/items", payload, 'POST').then((response: { List: IAthlete[], AllCount: number }) =>
		{
			if (response)
			{
				if (!this._AllCount)
					this._AllCount = response.AllCount;

				this._Athletes = response.List.map(el =>
				{
					let name = el.LastName;
					if (!name)
						name = el.FirstName;
					else
						name = el.LastName + " " + el.FirstName;

					return {
						Athlete: el,
						Name: name.trim(),
						Country: el.CountryName ? el.CountryName : '',
						WeightCat: getWeightStringById(el.WeightCategory),
						Rating: el.Rating,
						Image: AthletesList.getAthleteImage(el),
						BoutsCount: el.BoutsCount || 0
					}
				});

				this._dataTable.setShowPaginator(this._AllCount > this._Count);

				this._dataTable.getRightPagButton().setEnabled(this._Offset + this._Count < this._AllCount);
				this._dataTable.updatePagCaption(`${this._Offset + 1} - ${Math.min(this._Offset + this._Count, this._AllCount)} ${NP.RM.getString("of")} ${this._AllCount}`);
				this._dataTable.getLeftPagButton().setEnabled(this._Offset > 0);

				this._dataTable.setRows(this._Athletes);
				this.setHeight(this._Height);
			}
		});
	}

	setHeight(value: number)
	{
		super.setHeight(value);
		if (this._dataTable)
			this._dataTable.setHeight(value);
	}

	setWidth(value: number)
	{
		super.setWidth(value);
		if (this._dataTable)
			this._dataTable.setWidth(value);
	}
}